export const IFRAMED = !!(window.parent && window.parent.location !== window.location);

export function domain() {
  return window.CREDERE._INTERNAL?.domain;
}

export function endpoint() {
  return window.CREDERE._INTERNAL?.endpoint;
}

// How the host switches screens, declared by it because there is no way to find out from here:
// `document` loads another page and `client`, the default, swaps the view in the same document.
// Only the first one does without the blank curtain.
export function blankless() {
  return window.CREDERE._INTERNAL?.navigation === 'document';
}

export default function parent() {
  if (endpoint()) {
    return window;
  }

  return IFRAMED ? window.parent : window;
}
